/*
 * @Author: zhushitao
 * @Date: 2021-10-28 15:46:07
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-11-19 11:22:22
 * @Description:
 */
import {
  DIALOG_STATUS,
  DIALOG_TYPE,
  SEND_TYPE,
  USER_STATUS,
} from '../constants/status';
import dialogHeart from '../lib/heart';
import queue from '../lib/queue';
import { logger } from '../lib/metrics';
import { AppContextType, CombineMessageType } from '../lib/type';
import store from '../store/cache';

let firstTransferAgent = false;
let getAgentFirstMessageDone = false;
const getAgentFirstMessage = (messages?: CombineMessageType[]) => {
  const reverseMessages = messages?.map((item) => ({ ...item })).reverse();
  const lastMessageFromAgent = reverseMessages?.find(
    (message: any) =>
      !message.isFromMe && message.ext?.senderType === SEND_TYPE.AGENT,
  );
  return lastMessageFromAgent;
};

const dialogChange = async (ctx: AppContextType) => {
  const dialogStatus = Number(ctx.dialog?.ext?.status);
  const dialogType = Number(ctx.dialog?.ext?.type);

  if (store.get('debug')) {
    console.debug('dialogChange', ctx.dialog);
  }
  //There may be pits here, it will be cold in case of a surge in business
  if (+ctx.dialog?.ext?.dialogId >= +ctx.dialogInfo?.id) {
    ctx.dialogInfo = {
      ...ctx.dialogInfo,
      type: Number(ctx.dialog?.ext?.type),
      status: Number(ctx.dialog?.ext?.status),
      id: ctx.dialog?.ext?.dialogId,
    };
  }
  /**
   * @desc 指标 第一条转人工消息
   * 说明有该会话转过人功的过程，并且收到了人工消息
   */
  if (
    dialogType === DIALOG_TYPE.AGENT &&
    dialogStatus === DIALOG_STATUS.PENDING
  ) {
    if (!firstTransferAgent) {
      logger.info('linkchat.transferAgentSuccess', {
        dialogExt: ctx.dialog?.ext,
      });
      firstTransferAgent = true;
    }
    if (!getAgentFirstMessageDone) {
      const lastMessageFromAgent = getAgentFirstMessage(ctx.messages);
      if (lastMessageFromAgent?.serverId) {
        getAgentFirstMessageDone = true;
        logger.info('linkchat.getFirstAgentMessage', {
          dialogExt: ctx.dialog?.ext,
          message: {
            ...lastMessageFromAgent,
            _id: lastMessageFromAgent?.serverId,
          },
        });
      }
    }
  } else {
    getAgentFirstMessageDone = false;
    firstTransferAgent = false;
  }

  // Keep heartbeat polling as long as the session is not over
  if (
    dialogStatus !== DIALOG_STATUS.ENDING &&
    ctx.ext?.userStatus !== USER_STATUS.Leave &&
    ctx.dialog?.dialogId
  ) {
    dialogHeart?.run(ctx);
  } else {
    dialogHeart?.stop();
  }

  // In the case of status = 2, during the transfer, a queuing interface poll is initiated
  if (dialogStatus === DIALOG_STATUS.QUEUEING) {
    queue?.run(ctx);
  } else {
    queue?.stopQueue();
    ctx.ext = {
      ...ctx.ext,
      waitingNumber: 0,
      inWaiting: false,
    };
  }
};

export default dialogChange;
